import styled from 'styled-components'
import { Image } from '@sainsburys-tech/bolt'

const Container = styled.div`
  width: 370px;
  padding-bottom: 20px;

  @media only screen and (max-width: 425px) {
    width: unset;
  }
`

const BarContainer = styled.div`
  width: calc(50% - 5px);
  margin-bottom: 5px;
`

const BoxContainer = styled.div`
  display: flex;
  margin: 10px 0px;
  justify-content: space-between;

  @media only screen and (max-width: 425px) {
    margin: 10px -15px; /* Negative margin needed to offset the padding on the bolt accordion component when in mobile */
    justify-content: space-around; /* iOS 9 fix */
  }
`

const Subattributes = styled.div`
  justify-content: space-between;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
`

const Subheading = styled.span`
  display: inline-flex;
  margin-left: 5px;
  color: ${props => props.theme.color.monochrome.dark};
`

const RatingBreakdown = styled.div`
  display: flex;
  > div {
    flex: auto;
  }
`

const Pill = styled.span`
  height: 29px;
  width: 75px;
  margin-bottom: 5px;
  margin-right: 10px;
  border: solid 1px ${props => props.theme.color.monochrome.light};
  align-items: center;
  display: flex;
  font-weight: ${props => props.theme.font.weight.regular};
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
`

const AboutContainer = styled.div`
  border: solid 1px ${props => props.theme.color.monochrome.light};
  border-radius: 3px;
  margin-bottom: 30px;
`

const AboutTitle = styled.h5`
  color: ${props => props.theme.color.palette['brand-1']};
  font-size: ${props => props.theme.font.size.caption};
  align-items: center;
  display: flex;
  &&& {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const Trustmark = styled(Image)`
  height: 18px;
  margin-left: 10px;
`

const Text = styled.p`
  font-size: ${props => props.theme.font.size.caption};
  &&& {
    margin-bottom: 0px;
    line-height: 1rem;
  }
`

const FitContainer = styled.div`
  border: solid 1px ${props => props.theme.color.monochrome.light};
  border-radius: 3px;
  padding: 15px;
`

const FittingTitle = styled.p`
  margin-top: 30px;
  &&& {
    font-weight: ${props => props.theme.font.weight.bold};
  }
`

const FitAsExpected = styled.span`
  color: ${props => props.theme.color.palette['brand-1']};
  align-items: center;
  display: flex;
  position: relative;
  font-weight: ${props => props.theme.font.weight.bold};
  padding-right: 20px;
  cursor: pointer;

  > svg {
    position: absolute;
    right: 0px;
    align-self: center;
  }
`

const FitLabels = styled.p`
  width: 85px;
  margin-right: 10px;
  text-align: right;
`

const ModalBreakdown = styled.div`
  margin-top: 30px;
  margin-bottom: 130px;
`

export {
  Container,
  BarContainer,
  BoxContainer,
  Subattributes,
  Subheading,
  RatingBreakdown,
  Pill,
  AboutContainer,
  AboutTitle,
  Trustmark,
  Text,
  FitContainer,
  FittingTitle,
  FitAsExpected,
  FitLabels,
  ModalBreakdown
}
